/**
 * Rollup status values for onboarding items.
 * These values match the rollupStatus strings returned from the API.
 */
export enum RollupStatus {
    NotStarted = 'Not Started',
    InProgress = 'In progress',
    Completed = 'Completed',
    Expired = 'Expired',
}

/**
 * Converts a rollup status string from the API to the RollupStatus enum.
 * The API returns string values like "Not Started", "In progress", etc.
 */
export const toRollupStatus = (statusString: string | undefined): RollupStatus | undefined => {
    if (!statusString) return undefined;
    
    // Direct match with enum values
    const enumValues = Object.values(RollupStatus);
    if (enumValues.includes(statusString as RollupStatus)) {
        return statusString as RollupStatus;
    }
    
    // Fallback for case-insensitive matching
    const normalizedStatus = statusString.toLowerCase().trim();
    switch (normalizedStatus) {
        case 'not started':
            return RollupStatus.NotStarted;
        case 'in progress':
            return RollupStatus.InProgress;
        case 'completed':
            return RollupStatus.Completed;
        case 'expired':
            return RollupStatus.Expired;
        default:
            return undefined;
    }
};
